import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import { db } from '../main'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// https://medium.com/vue-mastery/vuex-explained-visually-f17c8c76d6c4
export default new Vuex.Store({
		state: {
				userAuth: null, // where we store the object we get from FB auth
				authChecked: false, // flag used to determine if we've checked for a user or not
				userData: null // Where we keep the data we have on the user
		},
		mutations: {
			SET_USERAUTH(state, payload){
				// console.log('setting SET_USERAUTH:', payload)
				state.userAuth = payload
				state.authChecked = true;
				
			},
			SET_USERDATA(state, payload){
				state.userData = payload
			},
			SET_AUTHCHECKED(state, payload){
				state.authChecked = payload
			}
		},
		actions: {
			setAuthChecked({ commit }, payload) {
				commit('SET_AUTHCHECKED', payload)
			},
			// eslint-disable-next-line
			setUserAuth ({commit, dispatch}, payload) {

				console.log("setting userAuth:", payload);
				return new Promise(async (resolve, reject)=>{
					try {
						if(!payload){
							// 're setting the user as null
							commit('SET_USERAUTH', null)
							resolve()
						} else {
	
							commit('SET_USERAUTH', payload)
							resolve(payload)
	
							// get the user's data
							// let userData = await dispatch('getUserData', payload)
							// if(!userData){
							// 	reject({'message':"no data for that user"})
							// } else {
							// 	commit('SET_USERDATA', userData)
							// 	resolve(userData)
							// }
						}
					} catch {
						reject("err setUserAuth")
					}
				})
			},
			// eslint-disable-next-line
			setUserData ({commit, dispatch}, payload) {

				console.log("setting userData:", payload);
				return new Promise(async (resolve, reject)=>{
					try {
						if(!payload){
							// 're setting the user data as null - logging out
							commit('SET_USERDATA', null)
							resolve()
						} else {
							// set the data
							commit('SET_USERDATA', payload)
							resolve(payload)
							// let userData = await dispatch('getUserData', payload)
							// if(!userData){
							// 	reject({'message':"no data for that user"})
							// } else {
							// 	commit('SET_USERDATA', userData)
							// 	resolve(userData)
							// }
						}
					} catch {
						reject('err setting user data');
					}
				})
			},
			refreshUserData({commit}, payload) {
				// takes a user's email address to update the data
				return new Promise(async (resolve, reject)=>{
					try {
						let doc = await db.collection("users").doc(payload).get()
						let userData = doc.data();
						userData.id = doc.id;
						commit('SET_USERDATA', userData)
						resolve(userData)
					} catch (e){
						reject({"message":`something went wrong: ${e}`})
					}
				})
			},
			getUserData({commit}, payload) {

				return new Promise(async (resolve, reject)=>{
					// console.log("getting user data:", payload)

					db.collection("users").doc(payload.email)
						.get()
						.then(doc=>{

							if(doc.exists){
								// save user data
								let userData = doc.data();
								userData.id = doc.id;
								commit('SET_USERDATA', userData)
								resolve(doc.data())
							} else {
								reject({"message":"no data for that user"})
							}

						})
						.catch(err=>{
							// console.log('error caught:', err);
							reject(err);
						})
				})
			},
			signIn ({commit, dispatch}, payload){
				// console.log("signing user IN from store:", payload)
				return new Promise((resolve, reject) => {
					firebase.auth()
						.signInWithEmailAndPassword(
							payload.email, 
							payload.password)
						.then(data=>{
							console.log('firebase auth data:', data);

							// save auth data
							commit('SET_USERAUTH', data.user)

							// go get user's data from our DB
							dispatch('getUserData', data.user)

							// resolve
							resolve(data.user);
	
						})
						.catch(err=> {
							reject(err)
						})
				})
			},
			// eslint-disable-next-line
			signUp ({commit, dispatch}, payload) {
				// console.log("signing user UP from store:", payload);
				return new Promise( async (resolve, reject) => {

					let newUserAuth;
					// attempt to sign user up
					try {
						newUserAuth = await firebase
							.auth()
							.createUserWithEmailAndPassword(
								payload.email, 
								payload.password
							)
					} catch(e){
						console.log('err signing new user up:', e)
						return reject(e)
					}

					// set userAuth state
					dispatch('setUserAuth', newUserAuth.user)

					let obj = {
						"dashboardName": payload.dashboardName,
						"email": payload.email,
						"uid": newUserAuth.user.uid
					}

					// create user obj and dashboard for user (api call)
					try {
						 await dispatch('createDashboard', obj)
					} catch (e) {
						console.log('err creating user/dashboard:', e)
						return reject(e)
					}

					// get the user data
					let userData = await dispatch('getUserData', newUserAuth.user)
					dispatch('setUserData', userData);

					console.log("singed user up, and ran getUserData")
					resolve(obj);

				})
			},
			// eslint-disable-next-line
			createDashboard({commit}, payload){
				// console.log('creating user dashboard:', payload);
				return new Promise(async (resolve, reject)=>{
					let obj = {
						"dashboardName": payload.dashboardName,
						"uid": payload.uid,
						"email": payload.email
					 }
					fetch('/api/create/dashboard', {
							method: 'post',
							body: JSON.stringify(obj),
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
							}
						})
						.then(response => {
							return response.json();
						})
						.then(data => {
							// console.log('created dash data:', data)
							if(data.error){
								reject(data)
							} else {
								resolve(data)
							}
						})
						.catch(err=>{
							reject(err)
						})
				})

			},
			signOut({commit}) {
				return new Promise((resolve, reject)=>{
					firebase.auth()
						.signOut()
						.then(()=>{
							commit('SET_USERAUTH', null)
							commit('SET_USERDATA', null)
							resolve()
						})
						.catch(err=>{
							reject(err)
						})
				})
			}
		},
		getters: {
			authChecked(state){
				return state.authChecked
			},
			userAuth(state){
				return state.userAuth
			},
			userData(state){
				return state.userData
			},
			checkAuthStatus(state) {
	      // console.log("running checkAuthStatus()")
	       return new Promise((resolve, reject) => {
	        try {
	          firebase.auth()
	           .onAuthStateChanged(user => {
	               console.log('userChecked:', user)
	               resolve(state.user);
	           });
	        } catch {
	          reject('api failed')
	        }
	      });
	    }
		}
});